/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPolyS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m18.635 7.94 3.584 1.956-3.566 10.38-7.316 1.872-2.933-4.61-4.603 1.69-.217-1.162a495.475 495.475 0 0 1-1.038-5.71c-.166-.958-.313-1.83-.41-2.474-.05-.32-.088-.594-.111-.797a4.16 4.16 0 0 1-.024-.288 1.526 1.526 0 0 1 .002-.18c.003-.036.01-.104.03-.184.012-.044.067-.27.267-.471L7 3.546l.218-.204.295-.052 8.1-1.402z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPolyS as PolyS };
